"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var LinkedinSquare = function LinkedinSquare(_ref) {
  var color = _ref.color,
      width = _ref.width,
      lineCap = _ref.lineCap,
      lineJoin = _ref.lineJoin;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: color,
    stroke: "none",
    strokeWidth: width,
    strokeLinecap: lineCap,
    strokeLinejoin: lineJoin
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16zM8.95 9.4H6.16v8.1h2.8V9.4zm6.84-.19c-1.32 0-2 .63-2.38 1.16l-.13.18V9.4h-2.79l.01.49V17.5h2.78v-4.52a1.52 1.52 0 0 1 1.52-1.64c.96 0 1.37.66 1.41 1.66v4.5H19v-4.64c0-2.49-1.37-3.65-3.2-3.65zM7.58 5.5C6.62 5.5 6 6.1 6 6.9c0 .73.54 1.32 1.38 1.4h.18c.97 0 1.57-.62 1.57-1.4-.01-.8-.6-1.4-1.55-1.4z"
  }));
};

LinkedinSquare.propTypes = {
  color: _propTypes.default.string,
  width: _propTypes.default.string,
  lineCap: _propTypes.default.string,
  lineJoin: _propTypes.default.string
};
LinkedinSquare.defaultProps = {
  color: '#000000',
  width: 'initial',
  lineCap: 'initial',
  lineJoin: 'initial'
};
var _default = LinkedinSquare;
exports.default = _default;